import styled from '@emotion/styled';

export const Notification = styled('div')({
  display: 'flex',
  position: 'absolute',
  top: 42,
  right: 22,
  width: 28,
  height: 28,
  backgroundPosition: 'center',
  backgroundColor: 'transparent',
});

export const NotificationActive = styled(Notification)({});

export const Notif = styled('div')({
  display: 'flex',
  minWidth: 28,
  width: 28,
  height: 28,
  backgroundPosition: 'center',
  backgroundColor: 'transparent',
});

export const Active = styled('div')({
  display: 'flex',
  minWidth: 8,
  width: 8,
  height: 8,
  backgroundPosition: 'center',
  backgroundColor: 'transparent',
});
